export default __webpack_public_path__ + "static/media/cheked-icon-orange.7617848b.svg";